module.exports = __webpack_public_path__ + "static/media/FORMATO CERTIFICADO CALIFICACIONES CENACAD.789de2f2.pdf";